import { Flexbox } from "@sede-x/shell-ds-react-framework";
import styled from "styled-components";

export const AnomalyTableDetailSectionContainer = styled(Flexbox)``;
